/** Formas cuja `descricao` guarda a chave em JSON (`{"chave":"..."}`). */
export const FORMAS_COM_CHAVE = ['Pix', 'BDM Digital'];

export function formaTemChave(nomeForma?: string | null): boolean {
  return FORMAS_COM_CHAVE.includes(String(nomeForma ?? ''));
}

/**
 * Lê a chave gravada em `forma_pagamento_empresa.descricao`.
 *
 * O formato esperado é `{"chave":"..."}`, mas há dados fora dele: a criação
 * automática das formas gravava o NOME da forma ali (ex.: "BDM Digital"), e
 * fluxos antigos gravaram a chave crua (ex.: um CPF). Um `JSON.parse` direto
 * derrubava a tela inteira. Aqui: JSON com `chave` → a chave; valor cru que não
 * seja o nome da forma → o próprio valor; o resto → ''.
 */
export function lerChave(
  descricao?: string | null,
  nomeForma?: string | null,
): string {
  const texto = String(descricao ?? '').trim();
  if (!texto) return '';

  let valor: unknown;
  try {
    valor = JSON.parse(texto);
  } catch {
    valor = texto;
  }

  if (valor && typeof valor === 'object') {
    const { chave } = valor as { chave?: unknown };
    return typeof chave === 'string' || typeof chave === 'number'
      ? String(chave)
      : '';
  }

  const cru = String(valor);
  return nomeForma && cru.toLowerCase() === nomeForma.toLowerCase() ? '' : cru;
}
